import { FontStyleModel } from '~/models/general/FontModel'
import { getBorder } from '~/models/general/BorderModel'
import { formatFontStyle } from "~/models/layout/style/font";
import { formatPadding, formatMargin } from "@/models/layout/style/index"


export default class ContentDetails {
  constructor(){
    this.id = null
  }

  fromData(data){
    this.id = data.id
  }
}

class ContentEngagementsStyleModel {
  constructor() {
    this.backgroundColor = ''
    this.padding = null
    this.margin = null
    this.gap = null
    this.borderWidth = null
    this.borderRadius = null
    this.borderStyle = null
    this.borderColor = null
    this.fontStyle = null
  }

  fromData({
    bgColor = '',
    padding = null,
    margin = null,
    spacing = 0,
    borderProperties = null,
    fontProperties = null,
  }) {
    this.backgroundColor = bgColor

    if (spacing) this.gap = `${spacing}px`

    if (padding)
      this.padding = `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`

    if (margin)
      this.margin = `${margin.top}px ${margin.right}px ${margin.bottom}px ${margin.left}px`

    if (borderProperties) {
      const { borderWidth, borderRadius, borderStyle, borderColor } = getBorder(borderProperties)
      this.borderWidth = borderWidth
      this.borderRadius = borderRadius
      this.borderStyle = borderStyle
      this.borderColor = borderColor
    }

    if (fontProperties) {
      const fontStyle = new FontStyleModel()
      fontStyle.fromData(fontProperties)
      this.fontStyle = fontStyle
    }
  }
}

export function formatContentEngagementsStyle(data) {
  const temp = new ContentEngagementsStyleModel()
  temp.fromData(data)

  return temp
}

export function formatContentComponentStyle(data) {
  const { fontProperties = null, padding = {}, margin = {} } = data
  return {
    ...(fontProperties ? formatFontStyle(fontProperties) : {}),
    ...formatMargin(margin),
    ...formatPadding(padding),
  }
}
